@for (modalInputs of modalsInputs; track modalInputs.id) {
  <ng-container *ngComponentOutlet="modalClass; inputs: modalInputs"></ng-container>
}
